import { CampaignType } from 'cio/models/campaign';
import { ConditionType } from 'cio/utils/condition-types';

export const WAIT_UNTIL_ACTION_SUPPORTED_CONDITION_TYPES = [
  ConditionType.SegmentsNegatable,
  ConditionType.Attribute,
  ConditionType.Event,
  ConditionType.Message,
];

export const CAMPAIGN_TYPES_WITH_EVENT_TIME_SUPPORT = new Set([CampaignType.Transactional, CampaignType.Form]);
